@if (isLoading()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center glass-background">
    <div class="pc-loader" role="status" aria-live="polite">
      <span class="pc-loader-aurora" aria-hidden="true"></span>
      <span class="pc-loader-ring" aria-hidden="true"></span>
      <img
        class="pc-loader-mark drop-shadow-xl"
        [src]="
          host1 === 'medicamenta' ||
          host2 === 'medicamenta' ||
          host2 === 'conecta' ||
          host2 === 'adidigital'
            ? '../../../../assets/images/medicamenta/isologo.png'
            : '../../../../assets/images/logo/logo.png'
        "
        alt="Cargando"
      />
    </div>
  </div>
}
